module.exports = __webpack_public_path__ + "static/Integrity_Inspections-new_home_photo_journal-67d3c9d3fb3926ecf5afa56b885d0ddc.pdf";